import * as React from "react";
const SvgRemove = () => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1.834a6.167 6.167 0 1 0 0 12.333A6.167 6.167 0 0 0 8 1.834M.835 8a7.167 7.167 0 1 1 14.333 0A7.167 7.167 0 0 1 .834 8m4.389-2.778a.5.5 0 0 1 .707 0L8 7.293l2.071-2.07a.5.5 0 0 1 .707.706L8.708 8l2.07 2.07a.5.5 0 1 1-.707.708l-2.07-2.07-2.071 2.07a.5.5 0 0 1-.707-.707L7.293 8l-2.07-2.072a.5.5 0 0 1 0-.707",
    clipRule: "evenodd"
  }
));
export default SvgRemove;
